// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4d15add3","453":"19db2ebf","455":"543d11c1","977":"bd37392b"}[chunkId] + ".chunk.js";
};